/**
 * Google bills autocomplete keystrokes as one session when they share a token and
 * the session is closed by a Place Details call, so suggest hooks generate a token
 * once, reuse it until a selection, then reset.
 */
export function generateSessionToken(): string {
  try {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
      return crypto.randomUUID();
    }
  } catch {
    // fall through
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
